<template>
    <div class="wrapper">
        <!-- Label -->
        <label-generic
        v-if="topLabel"
        :text="topLabel"/>
        <!-- Div for internal clicks without changing route -->
        <div
        v-if="internalClick"
        class="button-link"
        :class="{'disabled': disabled, 'secondary': secondary}"
        @click="emit('clicked')">{{label}}</div>
        <!-- anchor for clicks that will change route -->
        <a
        v-else
        :href="linkUrl"
        :target="openLinkInNewTab ? '_blank' : null"
        class="button-link"
        :class="{'disabled': disabled, 'secondary': secondary}">{{label}}</a>
    </div>
</template>

<script setup>
import LabelGeneric from '@/components/generic/labels/Generic'

/* Emmitters */
const emit = defineEmits(['clicked'])

/** Props received:
@secondary {Boolean} - prop to apply secondary variant styles
@linkUrl {String} - link to open
@label {String} - text to display in our button
@disabled {Boolean}
@openLinkInNewTab {Boolean} - prop to open our link in a new tab "target=_blank"
@internalClick {Boolean} - prop to emit a click event instead of redirect to link url
@topLabel {String} - if you need to display a top label
*/
const props = defineProps({
    secondary: Boolean,
    linkUrl: String,
    label: String,
    disabled: Boolean,
	openLinkInNewTab: Boolean,
    internalClick: Boolean,
    topLabel: String
})
</script>

<style lang="scss" scoped>
.wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
    .button-link {
        width: auto;
        height: 16px;

        @include H7-Medium;
        color: var(--primary);
        text-decoration: underline;
        line-height: 16px;
        cursor: pointer;

        &.secondary {
            color: var(--secondary-light-4);
        }

        @media (hover: hover) and (pointer: fine) {
            &:hover {
                color: var(--button-primary-state-hover);
                text-decoration: none;

                &.secondary {
                    color: var(--button-secondary-state-hover);
                }
            }
        }

        &:focus {
            color: var(--button-primary-state-press);
            text-decoration: none;

            &.secondary {
                color: var(--button-secondary-state-press);
            }
        }

        &.disabled {
            opacity: 0.24;
            text-decoration: none;
            pointer-events: none;
        }
    }
}
</style>
